var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBoolean = function SvgBoolean(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.42266 8.73218C0.446352 9.70849 0.446352 11.2914 1.42266 12.2677L8.1991 19.0442C9.17541 20.0205 10.7583 20.0205 11.7346 19.0442L18.5111 12.2677C19.4874 11.2914 19.4874 9.70849 18.5111 8.73218L11.7346 1.95574C10.7583 0.979433 9.17541 0.979433 8.1991 1.95574L1.42266 8.73218ZM2.60117 11.0892C2.27574 10.7638 2.27574 10.2361 2.60117 9.9107L9.37761 3.13426C9.54875 2.96312 9.77579 2.88198 9.99995 2.89083V18.1091C9.77579 18.1179 9.54875 18.0368 9.37762 17.8656L2.60117 11.0892Z",
    fill: "#4F4E65"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBoolean);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/boolean.70f01d76612dfdd5f024836e111d661e.svg";